import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const GOLD = "#C9A84C";

/** Pill switch: the gold knob sits left (moon) in dark mode and slides right (sun) in light mode. */
export const ThemeToggle = ({ className = "", showLabel = true }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      role="switch"
      aria-checked={!dark}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      className={`inline-flex items-center gap-2 h-11 min-w-[44px] px-1 select-none ${className}`}
      data-testid="theme-toggle"
      data-theme-state={dark ? "dark" : "light"}
    >
      <span
        className="relative w-[54px] h-7 rounded-full border shrink-0"
        style={{
          background: dark ? "#112240" : "#F8F9FA",
          borderColor: dark ? "rgba(201,168,76,0.4)" : "rgba(10,22,40,0.16)",
          transition: "background-color 0.3s ease, border-color 0.3s ease",
        }}
      >
        <Moon
          className="absolute left-[7px] top-1/2 -translate-y-1/2 w-3.5 h-3.5"
          style={{ color: dark ? "transparent" : "#9AA5B1", transition: "color 0.3s ease" }}
          aria-hidden
        />
        <Sun
          className="absolute right-[7px] top-1/2 -translate-y-1/2 w-3.5 h-3.5"
          style={{ color: dark ? "#7A879A" : "transparent", transition: "color 0.3s ease" }}
          aria-hidden
        />
        <span
          className="absolute top-[2px] left-[2px] w-[22px] h-[22px] rounded-full flex items-center justify-center"
          style={{
            transform: dark ? "translateX(0)" : "translateX(28px)",
            background: dark ? "rgba(201,168,76,0.16)" : "#FFFFFF",
            boxShadow: dark ? "0 0 0 1px rgba(201,168,76,0.5)" : "0 1px 3px rgba(10,22,40,0.28)",
            transition: "transform 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
          }}
        >
          {dark ? (
            <Moon className="w-3.5 h-3.5" style={{ color: GOLD }} />
          ) : (
            <Sun className="w-3.5 h-3.5" style={{ color: GOLD }} />
          )}
        </span>
      </span>
      <span
        className="text-[11.5px] font-medium tracking-wide"
        style={{
          color: dark ? "#FFFFFF" : "#0A1628",
          transition: "color 0.3s ease",
          display: showLabel ? undefined : "none",
        }}
        data-testid="theme-toggle-label"
      >
        {dark ? "Dark" : "Light"}
      </span>
    </button>
  );
};

export default ThemeToggle;
